import React from "react";
import styled from "styled-components";
import { colors } from "utils";

// Focused edit header (Figma 4884-52207). While a bundle is being edited the page
// drops to it alone, so the class line, the availability count and the Clear link
// sit here instead of in the fixed bottom bar. Shared by the lesson and standard
// bundle views so the two focused modes can't drift.
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 16px;
`;

const ClassLine = styled.div`
  align-items: center;
  color: ${colors.nightlyWoods500};
  display: flex;
  font-size: 18px;
  gap: 6px;
  letter-spacing: 0.25px;
  line-height: 26px;

  & strong { color: #000; font-weight: 700; }
`;

const Meta = styled.div`
  align-items: center;
  color: ${colors.nightlyWoods500};
  display: flex;
  font-size: 18px;
  gap: 16px;
  letter-spacing: 0.25px;
  line-height: 26px;
`;

const ClearLink = styled.button`
  background: transparent;
  border: none;
  color: ${colors.blue700};
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 26px;
  padding: 0;
  text-decoration: underline;
`;

export const FocusedEditHeader = ({ className, availableCount, totalGroups, onClear }) => (
  <Wrapper>
    {className && (
      <ClassLine>
        <strong>Class:</strong>
        <span>{className}</span>
      </ClassLine>
    )}
    <Meta>
      {/* The count lived on the save bar; it keeps its live region so trashing a
          code still announces the new availability. */}
      <span aria-live="polite" aria-atomic="true">
        {availableCount} of {totalGroups} Group Codes Available
      </span>
      {onClear && (
        <ClearLink type="button" onClick={onClear}>
          Clear More Group Codes
        </ClearLink>
      )}
    </Meta>
  </Wrapper>
);
